class LavaUpload extends HTMLElement {

  constructor() {
    super();
  }

  connectedCallback() {
    this.form = this.querySelector('form')
    this.fileInput = this.querySelector('input[type="file"]')
    this.dropZone = this.querySelector('#drop-zone')
    this.requiredInputs = this.querySelectorAll('input[required]')
    this.dropArea = this.querySelector('.droparea')
    this.fileInfo = this.querySelector('.file-info')
    this.submitButton = this.querySelector('button')

    this.pending = false;
    this.success = false;
    this.conflict = false;
    this.error = null;

    this.form.addEventListener('change', (event) => {
      this.dropArea.classList.remove('!border-theme-neutral-200');
      this.checkFileCount();
    });
    this.checkFileCount();


    window.addEventListener("drop", (e) => {
      if ([...e.dataTransfer.items].some((item) => item.kind === "file")) {
        e.preventDefault();
      }
    });

    this.dropZone.addEventListener("dragover", (e) => {
      const fileItems = [...e.dataTransfer.items].filter(
        (item) => item.kind === "file",
      );
      if (fileItems.length > 0) {
        e.preventDefault();
        if (fileItems.some((item) => item.type.startsWith("application/pdf"))) {
          e.dataTransfer.dropEffect = "copy";
          this.dropArea.classList.add('!border-theme-neutral-200');
        } else {
          e.dataTransfer.dropEffect = "none";
          this.dropArea.classList.remove('!border-theme-neutral-200');
        }
      }
    });

    this.dropZone.addEventListener('drop', (e) => {
      e.preventDefault();
      this.fileInput.files = e.dataTransfer.files;
      this.form.dispatchEvent(new Event('change'));
    });


    this.form.addEventListener('submit', (event) => {
      event.preventDefault();
      this.upload()
    });
  }

  checkFileCount() {
    let requiredFieldsMissing = false;
    this.requiredInputs.forEach((input) => {
      let val = input.value;
      if (input.type == 'checkbox') {
        val = input.checked;
      }
      if (!val) {
        requiredFieldsMissing = true;
      }
    });

    this.submitButton.disabled = this.fileInput.files.length < 1 || requiredFieldsMissing;
    this.submitButton.title = (this.fileInput.files.length < 1 || requiredFieldsMissing) ? 'Bitte geben Sie alle benötigten Daten an.' : '';

    if (this.fileInput.files.length > 0) {
      infoList = document.createElement('ul');
      for (const file of this.fileInput.files) {
        const infoListItem = document.createElement('li');
        infoListItem.textContent = file.name;
        infoList.append(infoListItem);
      }
      this.fileInfo.innerHTML = '<p class="font-bold">Ausgewählte Dateien</p>';
      this.fileInfo.appendChild(infoList);
    }
    else {
      this.fileInfo.innerHTML = '<p>Hier klicken, um PDF-Dateien auszuwählen oder per Drag & Drop ablegen.</p>';
    }
  }

  upload = async function upload() {
    this.pending = true;
    this.updateClasses();

    const formData = new FormData(this.form);
    const requestOptions = {
      method: "POST",
      body: formData,
      redirect: 'follow',
    }

    const response = await fetch(this.form.getAttribute('action'), requestOptions);
    if (response.status === 201) { // created
      this.success = true;
      // update ui
      response.json()
        .then((json) => {
        })
        .catch((error) => {
          this.error = true;
        });
    }
    else if (response.status === 409) { // conflict
      this.conflict = true;
    }
    else {
      this.error = true;
      response.json()
        .then((json) => {
          this.errorMessage = json.body;
        });
    }

    this.pending = false;
    this.updateClasses();
  }

  updateClasses() {
    this.classList.toggle('is-pending', this.pending);
    this.classList.toggle('has-success', this.success);
    this.classList.toggle('has-conflict', this.conflict);
    this.classList.toggle('has-error', this.error);
  }

}


// Define the new web component
if ('customElements' in window) {
  customElements.define('lava-upload', LavaUpload);
}
